import { timeline } from '@/mocks/chigua';

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-16 bg-ink-900 py-12 text-paper-100 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-heading text-sm font-bold tracking-widest text-ocher-300">{timeline.kicker}</span>
              <span className="h-px w-8 bg-ocher-300/70" />
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-paper-50 md:text-3xl">{timeline.title}</h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-paper-100/70">{timeline.intro}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5 md:gap-5">
          {timeline.steps.map((st, i) => (
            <div key={st.title} className="relative flex flex-col rounded-lg border border-paper-100/15 bg-paper-100/5 p-4 md:p-5">
              <div className="flex items-center justify-between">
                <span className="font-heading text-sm font-bold text-ocher-300">{st.tag}</span>
                <span
                  className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${
                    st.status === '已闭合'
                      ? 'bg-emerald-500/20 text-emerald-200'
                      : st.status === '含疑点'
                        ? 'bg-amber-500/20 text-amber-200'
                        : 'bg-accent-500/25 text-accent-100'
                  }`}
                >
                  {st.status}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-xl font-bold text-paper-50">{st.title}</h3>
              <p className="mt-1 text-xs text-paper-100/60">{st.date}</p>
              <p className="mt-3 flex-1 text-[13px] leading-[1.75] text-paper-100/80">{st.text}</p>
              {i < timeline.steps.length - 1 && (
                <span className="absolute -right-3 top-1/2 hidden -translate-y-1/2 text-paper-100/30 lg:block">
                  <i className="ri-arrow-right-s-line text-xl" />
                </span>
              )}
            </div>
          ))}
        </div>

        <p className="mt-6 flex items-center gap-2 text-xs text-paper-100/60">
          <i className="ri-information-line text-sm" />
          章末状态为编辑组当前判断，「未完待续」意味着该阶段存在未闭合的知情者爆料与内幕细节，仍在跟进。
        </p>
      </div>
    </section>
  );
}